export const capitaliseFirstLetter = (sentence: string | null) => {
  if (!sentence || sentence.length === 0) {
    return "";
  }
  return sentence[0]?.toUpperCase() + sentence.slice(1);
};

export const capitaliseFirstLetterOfEachWord = (sentence: string | null) => {
  if (!sentence) {
    return "";
  }
  return sentence
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/** Capitalises each segment after hyphens, e.g. "on-farm" → "On-Farm". */
export const capitaliseWordsWithHyphens = (sentence: string | null) => {
  if (!sentence) {
    return "";
  }
  return sentence
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("-");
};

export const uppercaseToSentenceCase = (sentence: string | null) => {
  if (!sentence) {
    return "";
  }
  return sentence
    .split(/[ _-]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
